var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物品类型名称", prop: "typeName" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { maxlength: "20" },
                model: {
                  value: _vm.childData.typeName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "typeName", $$v)
                  },
                  expression: "childData.typeName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  type: "textarea",
                  maxlength: "200",
                  autosize: { minRows: 3, maxRows: 3 }
                },
                model: {
                  value: _vm.childData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "remark", $$v)
                  },
                  expression: "childData.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }